import { Component, HostListener, Input, NgZone, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute} from '@angular/router';
import { User } from 'app/forms/validation/validation-forms.component';
import { AuthService } from 'app/shared/auth/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-landing-new',
  templateUrl: './landing-new.component.html',
  styleUrls: ['./landing-new.component.scss']
})
export class LandingNewComponent {

  loginFormSubmitted = false;
  isLoginFailed = false;

  isSticky: boolean = false;
  logoUrl: string = 'assets/logo-meander-white-new.png';


  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    rememberMe: new FormControl(true)
  });
  user: User;
  currentUrl:any
  constructor(private router: Router, private authService: AuthService,
    private route:ActivatedRoute,private ngZone: NgZone,
    private spinner: NgxSpinnerService, public toastr: ToastrService) {
      this.currentUrl=this.route.snapshot.routeConfig.path
     }

  get lf() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.loginFormSubmitted = true;
    if (this.loginForm.invalid) {
      return;
    }

    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
      this.authService.signinUser(this.loginForm.value, this.currentUrl)
      .subscribe((res: any) => {
          if (res && res?.data.roles === 'student') {
            this.spinner.hide()
            this.router.navigate(['/student-dashboard'])
          } else {
            this.toastr.error(res.error || 'An error occurred');
          }
      });
  
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event) {
    const scrollOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    // Adjust the threshold value as per your requirements
    this.isSticky = scrollOffset > 10; // Set a threshold value to determine when the header becomes sticky
    this.logoUrl = this.isSticky ? 'assets/logo-meander-black.png' : 'assets/logo-meander-white-new.png';
  }
}
